import React, { useState } from 'react';

import { useTranslation } from '@modernloop/i18n';
import { Dialog } from '@modernloop/shared/components';
import { Alert, AlertTitle, Stack, Typography } from '@mui/material';

import { useSelfScheduleOptionsDeleteMutation } from 'src/generated/mloop-graphql';

type Props = {
  selfScheduleOptionId: string;
  onContinue: () => void;
  onClose: () => void;
};

const SelfScheduleOpenAlert = ({ selfScheduleOptionId, onContinue, onClose }: Props) => {
  const { t } = useTranslation();
  const [errorMessage, setErrorMessage] = useState<string>();
  const [selfScheduleDelete, { loading: selfScheduleDeleting }] = useSelfScheduleOptionsDeleteMutation({
    variables: { id: selfScheduleOptionId },
  });

  const handleContinue = () => {
    selfScheduleDelete() // eslint-disable-next-line promise/always-return
      .then(() => {
        onContinue();
      })
      .catch((reason) => setErrorMessage(reason.message));
  };

  return (
    <Dialog
      open
      onClose={onClose}
      title={t('hiring-dashboard-schedule:schedule.dialog.headsUp')}
      submitOptions={{
        label: t('hiring-dashboard-common:common.continue'),
        isDisabled: selfScheduleDeleting,
        isLoading: selfScheduleDeleting,
        onClick: handleContinue,
      }}
      cancelOptions={{
        isDisabled: selfScheduleDeleting,
        label: t('hiring-dashboard-common:common.cancel'),
        onClick: onClose,
      }}
    >
      <Stack spacing={1}>
        {errorMessage && (
          <Alert severity="error">
            <AlertTitle>{errorMessage}</AlertTitle>
          </Alert>
        )}
        <Typography fontWeight={400}>
          {t('hiring-dashboard-schedule:schedule.selfSchedule.openRequestWarning')}
        </Typography>
      </Stack>
    </Dialog>
  );
};

export default SelfScheduleOpenAlert;
